import { Typography } from 'antd'
import React from 'react'

import { UserSidebarTaleUsage } from './user-sidebar-taleUsage.component'
import s from './user-sidebar.module.less'

export const UserSidebar: React.FC<{ userId: number }> = ({ userId }) => {
  const header = (icon: React.ReactNode, title: React.ReactNode) => (
    <div>
      <Typography.Title level={5}>
        {icon}
        {title}
      </Typography.Title>
    </div>
  )

  return (
    <div className={s.sidebar}>
      <UserSidebarTaleUsage userId={userId} getHeader={header} />
    </div>
  )
}
